import { render } from "./AuditTask.vue?vue&type=template&id=95fd0e70"
import script from "./AuditTask.vue?vue&type=script&lang=js"
export * from "./AuditTask.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__